import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        selected: {
            appointment: {},
            updates: []
        }
    },
    getters: {
        items: state => state.items,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
    },
    actions: {
        async index({ commit, rootState }, payload) {
            const response = await http.get('wideband/orders', {params: Object.assign(rootState.route.query, payload)});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            let response = await http.post('wideband/orders', payload);

            return response;
        },
        async feasibility({ commit }, payload) {
            let response = await http.post('wideband/orders/feasibility', payload);

            return response;
        },
        async sync({ commit }, type) {
            let response = await http.get('wideband/orders/sync', {
                params: {type}
            });

            commit('setItems', response.data);

            return response;
        }
    }
}